import axios from "./axios";
import store from "../store";

// Shared request helpers for birch-telematics-api.
//
// alert.service.js and alertConfiguration.service.js both call this API and had
// byte-identical private wrappers; a change to the request contract (headers,
// error handling, response unwrapping) had to be made in both or the two sets of
// calls would silently diverge. Both now import from here.

function customerHeaders() {
  return {
    customerId:
      store.getters.companyIdDropdown == null
        ? ""
        : store.getters.companyIdDropdown,
  };
}

export async function telematicsRequest(method, resource, data) {
  return axios
    .telematicsEndPoint({
      method,
      url: resource,
      data,
      headers: customerHeaders(),
    })
    .then((req) => {
      return req.data;
    });
}

export async function telematicsFileRequest(method, resource, data) {
  return axios
    .telematicsEndPoint({
      method,
      url: resource,
      data,
      headers: customerHeaders(),
      responseType: "blob",
    })
    .then((req) => {
      return req.data;
    });
}

/**
 * Builds a query string with every value percent-encoded.
 *
 * Values reaching these endpoints include free-text search and group names, so
 * raw interpolation truncates on "&" and drops every later parameter on "#".
 * Keys with null/undefined values are still emitted as empty, matching what the
 * endpoints previously received.
 */
export function buildQuery(params) {
  return Object.entries(params)
    .map(([key, value]) => {
      const v = value === null || value === undefined ? "" : String(value);
      return `${encodeURIComponent(key)}=${encodeURIComponent(v)}`;
    })
    .join("&");
}
